// removed by extract-text-webpack-plugin
module.exports = {"base":"Statistics_base--2G4VD","divisions":"Statistics_divisions--3JaxQ","divisionItem":"Statistics_divisionItem--1JzlE","division":"Statistics_division--30UEG","division__6":"Statistics_division__6--2EK2x","division6":"Statistics_division__6--2EK2x","division__8":"Statistics_division__8--2osu-","division8":"Statistics_division__8--2osu-","division__10":"Statistics_division__10--YMCsO","division10":"Statistics_division__10--YMCsO","tables":"Statistics_tables--2ssHo","table":"Statistics_table--1Rdfo"};


//////////////////
// WEBPACK FOOTER
// ./containers/StrongholdExternal/components/Statistics/Statistics.scss
// module id = 3858
// module chunks = 13